<template>
  <v-simple-table>
    <!--header -->
    <thead>
      <tr>
        <th class="text-left">
          {{ $t('fresh-vue-audits.AuditViewTable.header-action') }}
        </th>
        <th class="text-center">
          {{ $t('fresh-vue-audits.AuditViewTable.header-date') }}
        </th>
        <th class="text-center">
          {{ $t('fresh-vue-audits.AuditViewTable.header-trigger') }}
        </th>
        <th class="text-left">
          {{ $t('fresh-vue-audits.AuditViewTable.header-old-values') }}
        </th>
        <th class="text-left">
          {{ $t('fresh-vue-audits.AuditViewTable.header-new-values') }}
        </th>
      </tr>
    </thead>
    <!-- data -->
    <tbody>
      <tr v-for="item in audits" :key="item.id">
        <!-- event -->
        <td class="text-no-wrap">
          <v-icon small class="mr-2">
            $freshvueaudits-action-{{ item.event }}
          </v-icon>
          <span>
            {{ item?.auditable?.__typename | auditTypename }}
            {{ item.event | auditEvent }}
          </span>
        </td>

        <!-- created_at -->
        <td class="text-no-wrap text-center">
          {{ item.created_at | date }}<br />
          {{ item.created_at | time }}
        </td>

        <!-- user -->
        <td class="text-no-wrap text-center">
          {{ item?.user?.name || '-' }}
        </td>

        <!-- old_values -->
        <td class="text-no-wrap pa-1">
          <slot name="old-values" :values="JSON.parse(item.old_values)">
            <json-details :json="JSON.parse(item.old_values)" dense />
          </slot>
        </td>

        <!-- new_values -->
        <td class="text-no-wrap pa-1">
          <slot name="new-values" :values="JSON.parse(item.new_values)">
            <json-details :json="JSON.parse(item.new_values)" dense />
          </slot>
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import { JsonDetails } from '@freshsolutions/fresh-vue'

export default {
  name: 'AuditViewTable',

  components: {
    JsonDetails
  },

  props: {
    audits: {
      type: Array,
      required: false,
      default: null
    }
  }
}
</script>
